//
export { default } from './QueryRendererContainer';
